import { coerceBooleanProperty, coerceElement } from '@angular/cdk/coercion';
import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';

@Directive({
  selector: '[csStyleDisplay]',
  standalone: false
})
export class StyleDisplayDirective {
  private _type: string = 'block';
  @Input()
  public set type(val: string) {
    if (val) {
      this._type = val;
      const elm = coerceElement(this.elementRef);
      const styleVal = this.state ? val : 'none';
      this.renderer.setStyle(elm, 'display', styleVal);
    }
  }
  public get type(): string {
    return this._type;
  }

  @Input('csStyleDisplay')
  public set state(val: boolean | null | undefined | unknown) {
    val = !!val;
    this._state = coerceBooleanProperty(val);
    const elm = coerceElement(this.elementRef);
    const styleVal = this.state ? this._type : 'none';
    this.renderer.setStyle(elm, 'display', styleVal);
  }

  public get state(): boolean | null | undefined | unknown {
    return this._state;
  }

  public _state: boolean;

  constructor(
    private renderer: Renderer2,
    private elementRef: ElementRef<Element>
  ) {}
}
